/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { ReactComponent as Comment } from 'assets/icons/comment-ad.svg'
import AdPlacement from 'material/adplacement/adplacement';
// styles
import injectSheet from 'react-jss'
import styles from './preview_styles'
import Space from 'material/space/space';
import PreviewConfig from '../../previewconfig/previewconfig';
import { url } from 'utils/urls';

const Reply = ({ type = 'reply', children, version }) => {
  return (
    <Space direction={'column'}>
      <Space alignItems={'center'}>
        <div className='placeholder rounded'>
          {type === 'reply' ? 'R' : 'N'}
        </div>
        <div className='placeholder' style={{width: '88px'}} />
      </Space>
      <Space direction={'column'} style={children ? {marginLeft: '8px', paddingLeft: '24px', borderLeft: '1px solid #EEEFF1'}: {paddingLeft: '24px'}}>
        <div className='placeholder' style={{width: version === 'desktop' ? '246px' : '216px'}} />
        <div className='placeholder' style={{width: version === 'desktop' ? '200px' : '180px'}} />
        {children}
      </Space>
    </Space>
  )
}
/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADS SECTION: PREVIEW ~~~~~~~~~~ ========== */
const Preview = injectSheet(styles)((props) => {

  const {  
    showAdsBeforeCommentingUnit,
    showAdsAfterFirstComment,
    showAdsBetweenRootComments,
    adsCountBetweenRootComments,
    showAdsBetweenReplies,
    adsCountBetweenReplies,
    showAdsAfterLoadMoreButton,
    showAdsAfterCommentingUnit, 
    visibility,
    version
  } = props

  const showAds = visibility !== 'NONE'

  return (
    <Space justifyContent={'flex-end'} klass={`preview ${props.classes.preview}`} >
    <PreviewConfig klass={version} >
        <Space gap={12} klass={'adsconfigpreview'} direction={'column'} alignItems={'center'} justifyContent={'center'}>
          { showAdsBeforeCommentingUnit && showAds && <AdPlacement />}

          {/* Header */}
          <Space justifyContent={'space-between'} alignItems={'center'}>
            <Space alignItems={'center'}>
              <Comment width={18} height={18} />
              <h3>Comments</h3>
            </Space>
            <div className='placeholder' style={{width: '56px'}} />
          </Space>
          <div className={'divider'}/>
          <Space justifyContent={'space-between'} alignItems={'center'}>
            <Space alignItems={'center'}>
              <div className='placeholder rounded'>R</div>
              <div className='placeholder' style={{width: '88px'}} />
            </Space>
            <div className='placeholder rounded' />
          </Space>
          {/* Header */}

          <Reply version={version} />
          {showAdsAfterFirstComment && showAds &&  <AdPlacement />}

          {showAdsBetweenRootComments && showAds && (
            <>
              {Array.from(Array(adsCountBetweenRootComments)).map(() => <Reply />)}
              {showAdsBetweenRootComments && <AdPlacement />}
              {Array.from(Array(adsCountBetweenRootComments)).map(() => <Reply />)}
            </>
          )}

         {showAdsBetweenReplies && showAds && 
           <Reply>
            {Array.from(Array(adsCountBetweenReplies)).map(() => <Reply type='nested' />)}
            { showAdsBetweenReplies && (
              <div style={{ marginLeft: '24px'}}><AdPlacement /></div>
            )}
            {Array.from(Array(adsCountBetweenReplies)).map(() => <Reply type='nested' />)}
          </Reply>
         }

          <div className='loadmorebutton'>
            Load more comments
          </div>
          { showAdsAfterLoadMoreButton && showAds && <AdPlacement />}

          {/* Footer */}
          <div className='divider' />
          <Space justifyContent={'space-between'} alignItems={'center'}>
            <Space klass={'poweredby'} alignItems={'center'}>
                Powered by <img width={64} height={12} src={`${url.image}/2.0/logos/pub_gradient_dark.png`} />
              </Space>
            <Space justifyContent={'right'}>
              <div className='placeholder' style={{width: '34px'}} />
              <div className='placeholder' style={{width: '34px'}} />
              <div className='placeholder' style={{width: '34px'}} />
            </Space>
          </Space>
          { showAdsAfterCommentingUnit && showAds && <AdPlacement />}
          {/* Footer */}
        </Space>
      </PreviewConfig>
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Preview;